import gql from 'graphql-tag';

import embeddedIntegrationEmailFragment from './embeddedIntegrationEmailFragment';
import dokkioEmailFragment from './dokkioEmailFragment';
import dokkioThreadFragment from './dokkioThreadFragment';

export const integrationEmailFragment = gql`
  fragment integrationEmailFragment on IntegrationEmail {
    ...embeddedIntegrationEmailFragment
    dokkioEmail {
      ...dokkioEmailFragment
    }
    dokkioThread {
      ...dokkioThreadFragment
    }
  }
  ${embeddedIntegrationEmailFragment}
  ${dokkioEmailFragment}
  ${dokkioThreadFragment}
`;
export default integrationEmailFragment;
